import { css } from 'styled-components';

import GrinchedFont from './grinched.otf';

export const AoCFontStyles = css`
  @font-face {
    font-family: 'GrinchedFont';
    font-weight: normal;
    src: url(${GrinchedFont}) format('opentype');
  }
`;
